import QrCodeStore from "./QRCode/QRCodeStore";
import IFCTrackerStore from "./IFCTracker/IFCTrackerStore";
import HardwareOverviewScheduleStore from "./HardwareOverview/HardwareOverviewScheduleStore";
import PanelYardManagementStore from "./PanelYardManagement/PanelYardManagement.Store";

const inventoryAndFieldStoreList = [
    { name: "qrCodeStore", store: QrCodeStore },
    { name: "ifcTrackerStore", store: IFCTrackerStore },
    { name: "hardwareOverviewScheduleStore", store: HardwareOverviewScheduleStore },
    { name: "panelYardManagementStore", store: PanelYardManagementStore },
];

export default inventoryAndFieldStoreList;
